import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../api'

type VerifyOtpParams = {
  phone: string,
  token: string,
  type?: string | undefined,
}

const verifyOtp = async ({ phone, token, type }: VerifyOtpParams) => {
  const { data: sessionData } = await supabase.auth.getSession()
  const { data, error } = await supabase.auth.verifyOtp({
    phone: phone?.replace('+', ''),
    token,
    // @ts-ignore
    type: type || 'sms',
  })

  if (error) {
    // await supabase.auth.refreshSession({
    //   refresh_token: sessionData?.session?.refresh_token || '',
    // })
    await supabase.auth.setSession({
      access_token: sessionData?.session?.access_token || '',
      refresh_token: sessionData?.session?.refresh_token || '',
    })
    throw error
  }

  return data
}

export default function useVerifyOtp({ token, phone, type }: VerifyOtpParams) {
  const queryClient = useQueryClient()

  return useMutation(
    () => verifyOtp({ phone, token, type }),
    {
      onSuccess: () => {
        if (type !== 'phone_change') {
          queryClient.removeQueries({ queryKey: ['isAuth'] })
          queryClient.removeQueries({ queryKey: ['user'] })
          queryClient.removeQueries({ queryKey: ['profile'] })
        }
      },
    },
  )
}
